import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * SUB-COMPONENT: INDIVIDUAL FAQ ITEM
 * Each item manages its own open/close state independently.
 */
const FaqItem = ({ question, answer, defaultOpen = false }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className="border-b border-gray-200 last:border-0">
            <button
                className="w-full py-6 flex justify-between items-center text-left hover:text-blue-600 transition-all group"
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
            >
                <span className="text-lg font-semibold text-[#1A2B3C] group-hover:text-blue-600 pr-8">
                    {question}
                </span>
                <span className={`transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''}`}>
                    <ChevronDown
                        size={24}
                        className={isOpen ? 'text-blue-600' : 'text-gray-400'}
                    />
                </span>
            </button>

            {/* Smooth height transition */}
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[1000px] pb-6 opacity-100' : 'max-h-0 opacity-0'
                }`}>
                <p className="text-gray-600 leading-relaxed text-[16px]">
                    {answer}
                </p>
            </div>
        </div>
    );
};

/**
 * MAIN COMPONENT
 */
const FaqSection = ({ title, subtitle, faqs }) => {
    return (
        <section className="bg-white py-24 px-6">
            <div className="max-w-6xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-bold text-[#1A2B3C] mb-4">{title}</h2>
                    {subtitle && <p className="text-gray-500 text-lg">{subtitle}</p>}
                </div>

                {/* Content Box */}
                <div className="bg-[#F8FAFC] rounded-[2.5rem] p-8 md:p-12 shadow-sm border border-gray-50">
                    {faqs.map((faq, index) => (
                        <FaqItem
                            key={index}
                            question={faq.question}
                            answer={faq.answer}
                            // Logic: Only the first item (index 0) is open by default
                            defaultOpen={index === 0}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;